import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  details: [],
};

export const detailsSlice = createSlice({
  name: "companies",
  initialState,
  reducers: {
    setDetails: (state, action) => {
      state.details = action.payload;
    },
  },
});

export const { setDetails } = detailsSlice.actions;
export default detailsSlice.reducer;
